// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* index.css */

:root {
  --transition-default: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  --transition-smooth: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  --transition-bounce: 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  --shadow-subtle: 0 4px 20px rgba(0, 0, 0, 0.04);
  --shadow-medium: 0 8px 30px rgba(0, 0, 0, 0.08);
  --shadow-floating: 0 16px 40px rgba(0, 0, 0, 0.12);
}

body {
  margin: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f8fafc;
  color: #1e293b;
  overflow-x: hidden;
}

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

h1, h2, h3, h4, h5, h6, p {
  margin: 0;
  padding: 0;
  font-weight: 500;
}

a {
  text-decoration: none;
  color: inherit;
  transition: color var(--transition-default);
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

input, button, textarea, select {
  font-family: inherit;
  font-size: inherit;
}

button {
  cursor: pointer;
  transition: all var(--transition-default);
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.03);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.25);
}

/* Selection */
::selection {
  background-color: rgba(99, 102, 241, 0.2);
  color: #1e293b;
}

/* Global animations */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { 
    opacity: 0;
    transform: translateY(20px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRight {
  from { 
    opacity: 0;
    transform: translateX(20px);
  }
  to { 
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes pulseSubtle {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.8; }
}

.fade-in {
  animation: fadeIn 0.5s ease-out;
}

.slide-up {
  animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

.slide-in-right {
  animation: slideInRight 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.pulse-subtle {
  animation: pulseSubtle 2s ease-in-out infinite;
}

/* Page transition animations - APPLIED TO CONTENT ONLY, NOT BODY */
.page-transition-content {
  animation: pageFadeOut 0.3s ease-out forwards;
}

@keyframes pageFadeOut {
  from { opacity: 1; }
  to { opacity: 0.95; }
}

@keyframes pageFadeIn {
  from { opacity: 0.95; }
  to { opacity: 1; }
}

.page-enter-content {
  animation: pageFadeIn 0.4s ease-out forwards;
}

/* Card expand animation (for job details) */
@keyframes cardExpand {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-expand {
  animation: cardExpand 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

/* Backdrop for modal-like transitions */
.transition-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(4px);
  z-index: 9998;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.transition-backdrop.active {
  opacity: 1;
  pointer-events: all;
}

/* Ensure smooth transitions between pages - CONTENT ONLY */
.transition-content {
  transition: opacity 0.3s ease;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;EACE,uDAAuD;EACvD,0DAA0D;EAC1D,gEAAgE;EAChE,+CAA+C;EAC/C,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yCAAyC;AAC3C;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,cAAc;AACd;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,8CAA8C;AAChD;;AAEA,mEAAmE;AACnE;EACE,6CAA6C;AAC/C;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,aAAa,EAAE;AACtB;;AAEA;EACE,OAAO,aAAa,EAAE;EACtB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,4CAA4C;AAC5C;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;EACE,6BAA6B;AAC/B","sourcesContent":["/* index.css */\n\n:root {\n  --transition-default: 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  --transition-smooth: 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n  --transition-bounce: 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  --shadow-subtle: 0 4px 20px rgba(0, 0, 0, 0.04);\n  --shadow-medium: 0 8px 30px rgba(0, 0, 0, 0.08);\n  --shadow-floating: 0 16px 40px rgba(0, 0, 0, 0.12);\n}\n\nbody {\n  margin: 0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f8fafc;\n  color: #1e293b;\n  overflow-x: hidden;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nh1, h2, h3, h4, h5, h6, p {\n  margin: 0;\n  padding: 0;\n  font-weight: 500;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n  transition: color var(--transition-default);\n}\n\nul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\ninput, button, textarea, select {\n  font-family: inherit;\n  font-size: inherit;\n}\n\nbutton {\n  cursor: pointer;\n  transition: all var(--transition-default);\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.25);\n}\n\n/* Selection */\n::selection {\n  background-color: rgba(99, 102, 241, 0.2);\n  color: #1e293b;\n}\n\n/* Global animations */\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from { \n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to { \n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideInRight {\n  from { \n    opacity: 0;\n    transform: translateX(20px);\n  }\n  to { \n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes pulseSubtle {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.8; }\n}\n\n.fade-in {\n  animation: fadeIn 0.5s ease-out;\n}\n\n.slide-up {\n  animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.slide-in-right {\n  animation: slideInRight 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.pulse-subtle {\n  animation: pulseSubtle 2s ease-in-out infinite;\n}\n\n/* Page transition animations - APPLIED TO CONTENT ONLY, NOT BODY */\n.page-transition-content {\n  animation: pageFadeOut 0.3s ease-out forwards;\n}\n\n@keyframes pageFadeOut {\n  from { opacity: 1; }\n  to { opacity: 0.95; }\n}\n\n@keyframes pageFadeIn {\n  from { opacity: 0.95; }\n  to { opacity: 1; }\n}\n\n.page-enter-content {\n  animation: pageFadeIn 0.4s ease-out forwards;\n}\n\n/* Card expand animation (for job details) */\n@keyframes cardExpand {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.card-expand {\n  animation: cardExpand 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n@keyframes blink {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0; }\n}\n\n@keyframes shimmer {\n  0% { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n\n/* Backdrop for modal-like transitions */\n.transition-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.08);\n  backdrop-filter: blur(4px);\n  z-index: 9998;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n}\n\n.transition-backdrop.active {\n  opacity: 1;\n  pointer-events: all;\n}\n\n/* Ensure smooth transitions between pages - CONTENT ONLY */\n.transition-content {\n  transition: opacity 0.3s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
